

const themes = [
  { name:"Godis", colors:["#e75da7","#ffe45c","#f39a2d","#d9a071"], text:"#fff" },
  { name:"Regnbåge", colors:["#f5323f","#ff9918","#ffd21c","#4199d1","#46a941"], text:"#fff" },
  { name:"Purpur", colors:["#8f74a3","#b88499","#e2b7a9","#f3decf"], text:"#fff7dc" },
  { name:"Orkidé", colors:["#c8c1e4","#e8e2f1","#ffd0e4","#ff8fb9"], text:"#6d6b91" },
  { name:"Pastell", colors:["#f5ffb8","#7dc7e8","#ffd66b","#d7c1f2"], text:"#555" },
  { name:"Grön", colors:["#bed8b3"], text:"#557" },
  { name:"Blå", colors:["#4f92e8"], text:"#fff" },
  { name:"Gul", colors:["#ffe14f"], text:"#222" },
  { name:"Svart", colors:["#151515"], text:"#fff" },
  { name:"Teal", colors:["#438f90"], text:"#fff" },
  { name:"Beige", colors:["#c2957e"], text:"#fff" },
  { name:"Röd", colors:["#f65c55"], text:"#fff" },
  { name:"Orange", colors:["#f29a2e"], text:"#fff" },
  { name:"Lila", colors:["#b956e8"], text:"#fff" },
  { name:"Mint", colors:["#58c47b"], text:"#fff" },
  { name:"Mokka", colors:["#c7c7b4","#eee2d2","#b79b7c","#8b735d"], text:"#5a4638" },
  { name:"Svart mix", colors:["#111","#f8cf3a","#58b984","#46a4e9","#ef4e56"], text:"#fff" },
  { name:"Rosa", colors:["#c96c60","#f0d8ca","#d9ccd9","#eeb7c5"], text:"#fff" },
  { name:"Salvia", colors:["#8da083"], text:"#fff" },
  { name:"Brun", colors:["#b18672"], text:"#fff" },
  { name:"Ljusblå", colors:["#9cc6c8"], text:"#fff" },
  { name:"Mörkgrön", colors:["#347577"], text:"#fff" },
  { name:"Persika", colors:["#d9a98b"], text:"#fff" },
  { name:"Rosa lila", colors:["#e17cda"], text:"#fff" },
  { name:"Gul mix", colors:["#ffe86a","#8bd6e8","#8bc4a5","#df7f99"], text:"#555" },
  { name:"Jord", colors:["#4a5e45","#a48b62","#d6bd8c"], text:"#fff" },
  { name:"Svartvit", colors:["#fff","#111","#fff"], text:"#111" },
  { name:"Vit", colors:["#fff"], text:"#555" },
  { name:"Himmel", colors:["#c7ecfb"], text:"#4c7180" },
  { name:"Koral", colors:["#e7afa9"], text:"#fff" },
  { name:"Sand", colors:["#f9e9b8"], text:"#555" },
  { name:"Lavendel", colors:["#d7c1f2"], text:"#6d6b91" },
  { name:"Turkos", colors:["#00bcd4"], text:"#fff" },
  { name:"Lime", colors:["#cddc39"], text:"#222" },
  { name:"Karamell", colors:["#f36b28","#ffd64a","#2f8fba","#7d943e"], text:"#fff" },
  { name:"Höst", colors:["#99b67b","#e9b7bd","#d94337","#f7da42"], text:"#555" }
];

const colorSlider = document.getElementById("colorSlider");
const previewName = document.getElementById("previewName");
const nameInput = document.getElementById("nameInput");
const mainLabel = document.querySelector(".mainLabel");
const sheetPreview = document.getElementById("sheetPreview");

const layers = [
  document.querySelector(".layer1"),
  document.querySelector(".layer2"),
  document.querySelector(".layer3"),
  document.querySelector(".layer4")
];

let activeTheme = themes[0];

function getNameText() {
  return nameInput.value.trim() || "Maria";
}

function updatePreviewFontSize() {

  const value = getNameText();

  previewName.innerHTML = value.replaceAll(" ", "&nbsp;");

  let size = 58;
  previewName.style.fontSize = size + "px";

  const maxWidth = mainLabel.clientWidth - 36;

  while (previewName.scrollWidth > maxWidth && size > 18) {
    size--;
    previewName.style.fontSize = size + "px";
  }

  previewName.style.fontSize = size + "px";
  previewName.style.whiteSpace = "nowrap";
  previewName.style.maxWidth = "90%";
  previewName.style.overflow = "hidden";
}

function renderThemes() {
  colorSlider.innerHTML = "";

  themes.forEach(theme => {
    const box = document.createElement("div");
    box.className = "colorBox";
    box.style.gridTemplateRows = `repeat(${theme.colors.length}, 1fr)`;

    theme.colors.forEach(color => {
      const stripe = document.createElement("div");
      stripe.className = "colorStripe";
      stripe.style.background = color;
      box.appendChild(stripe);
    });

    if (theme === activeTheme) {
      box.classList.add("active");
    }

    box.addEventListener("click", () => {
      activeTheme = theme;
      renderThemes();
      applyTheme();
    });

    colorSlider.appendChild(box);
  });
}

function applyTheme() {
  const colors = activeTheme.colors;
  const text = getNameText();

  previewName.innerText = text;
  previewName.style.color = activeTheme.text;
 mainLabel.style.setProperty("--main-label-color", colors[0]);

  layers.forEach((layer, index) => {
    layer.style.background = colors[index + 1] || colors[0];
  });

  updatePreviewFontSize();
  renderSheet();
}

function getTextColor(bg) {
  const light = [
    "#ffe45c",
    "#ffd21c",
    "#ffe14f",
    "#fff",
    "#ffffff",
    "#f9e9b8",
    "#cddc39",
    "#bed8b3",
    "#c7ecfb",
    "#f5ffb8"
  ];

  return light.includes(bg.toLowerCase()) ? "#222" : "#fff";
}

function renderSheet() {
  sheetPreview.innerHTML = "";

  const text = getNameText();
  const colors = activeTheme.colors;

  for (let i = 0; i < 35; i++) {
    const sticker = document.createElement("div");
    const bg = colors[i % colors.length];

    sticker.className = "sticker";
    sticker.style.background = bg;
    sticker.style.color = getTextColor(bg);
    sticker.innerText = text;

    sheetPreview.appendChild(sticker);
  }
}

nameInput.addEventListener("input", applyTheme);

renderThemes();
applyTheme();


// ================================
// MINI LABELS - SHOPIFY CART
// ================================

let miniQuantity = 1;

const miniQtyMinus = document.getElementById("miniQtyMinus");
const miniQtyPlus = document.getElementById("miniQtyPlus");
const miniQtyValue = document.getElementById("miniQtyValue");
const miniAddToCartBtn = document.getElementById("miniAddToCartBtn");
const miniVariantId = document.getElementById("miniVariantId");

miniQtyPlus.addEventListener("click", () => {
  miniQuantity++;
  miniQtyValue.textContent = miniQuantity;
});

miniQtyMinus.addEventListener("click", () => {
  if (miniQuantity > 1) {
    miniQuantity--;
    miniQtyValue.textContent = miniQuantity;
  }
});

miniAddToCartBtn.addEventListener("click", () => {
  const nameValue = document.getElementById("nameInput").value.trim();
  const selectedTheme = document.querySelector(".color-card.active, .colorItem.active, .active");

  miniAddToCartBtn.disabled = true;
  miniAddToCartBtn.textContent = "LÄGGER TILL...";

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      id: miniVariantId.value,
      quantity: miniQuantity,
      properties: {
        "Rad 1": nameValue,
        "Theme": selectedTheme ? selectedTheme.dataset.name || selectedTheme.dataset.theme || "Selected theme" : "Default",
        "Product Type": "Små namnlappar"
      }
    })
  })
  .then(res => {
    if (!res.ok) throw new Error("Cart error");
    return res.json();
  })
  .then(() => {
    miniAddToCartBtn.textContent = "TILLAGD ✓";
    setTimeout(() => {
      window.location.href = "/cart";
    }, 700);
  })
  .catch(err => {
    console.error(err);
    miniAddToCartBtn.disabled = false;
    miniAddToCartBtn.textContent = "FÖRSÖK IGEN";
  });
});